import React from "react";
import { ApplicationState } from "./../store";
import { actions } from "./../store/Profile";
import { connect, ConnectedProps } from "react-redux";
import { useLocalValidation } from "../hooks/useLocalValidation";
import { TextInputGroupBaseEmail } from "./TextInputGroupBase.Email";

type ContactsEmailProps = ConnectedProps<typeof connector> & {
  forwardedRef?: any;
};

export const ContactsEmailInput: React.FC<ContactsEmailProps> = (props: ContactsEmailProps) => {
  const description = props.stateDescriptions[props.state];

  useLocalValidation({
    fieldName: "email",
    state: props.state,
    value: props.value,
    errorMessage: description,
  });

  return (
    <TextInputGroupBaseEmail
      forwardedRef={props.forwardedRef}
      input={{
        onChange: props.onChange,
        helperText: description,
        hasError: props.state > 0,
        value: props.value ?? "",
        id: "email",
        name: "email",
        autoComplete: "email",
      }}
      label={{
        title: props.title ?? "",
      }}
      help={{
        title: props.description?.title,
        description: props.description?.text,
      }}
    />
  );
};

const connector = connect((state: ApplicationState) => state.profile?.email, {
  onChange: actions.customerEmailChanged,
});

export default connector(ContactsEmailInput);
